var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"animatedBg"}},[_c('div',{staticClass:"wrap"},_vm._l((10),function(index){return _c('svg',{staticClass:"svg",attrs:{"xmlns":"http://www.w3.org/2000/svg"},domProps:{"innerHTML":_vm._s(_vm.svg)}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }